export default [
  {
    "id": 4,
    "type": "Mozu area",
    "description":
      "The Mozu area has a two-kilometer radius and is located in Sakai City. More than 100 tombs were created here from the late 4th century to the late 5th century. " +
      'Half of them, however, have been lost due to urbanization and other reasons, and currently 44 tombs remain. These include giant keyhole-shaped kofun, notably <a href="" class="mf-tooltip-to-detail" data-kofun="nintoku">Nintoku-tenno-ryo Kofun</a>, one of the world\'s largest burial mounds. '
  },
  {
    "id": 5,
    "type": "Furuichi area",
    "description":
      "The Furuichi area has a two-kilometer radius and is located between the cities of Fujiidera and Habikino in the southeastern part of Osaka Prefecture. " +
      "The group of huge mounded tombs, constructed from the late 4th century to the middle of the 6th century, originally comprised more than 130 examples of various shapes and scales. ranging from the 425-meter-long, " +
      'keyhole-shaped <a href="" class="mf-tooltip-to-detail" data-kofun="ojin">Ojin-tenno-ryo Kofun</a> (the second largest in Japan) to very small square tombs. Of the 45 tombs that remain, no fewer than seven are keyhole-shaped kofun over 200 meters in length. '
  },
  {
    "id": 6,
    "type": "Keyhole-shaped",
    "description":
      'These are shaped like a keyhole when seen from above, as if a round mound and a square mound have been joined together.' +
      'Most colossal kofun adopt this keyhole shape. Tombs of this shape are unique to Japan, and have been constructed continuously from the beginning to nearly the end of the Kofun Period.' +
      '<img width="200px" src="../sites/mozu-furu/assets/img/tooltip/keyhole.jpg" alt="keyhole-shaped tomb">'
  },
  {
    "id": 7,
    "type": "Scallop-shaped",
    "description":
      'This is a kind of keyhole-shaped kofun with the square front part shortened. Tombs of this shape were mainly constructed in the Middle Kofun Period.' +
      '<img width="240px" src="../sites/mozu-furu/assets/img/tooltip/scallop.jpg" alt="scallop-shaped tomb">'
  },
  {
    "id": 8,
    "type": "Round",
    "description": 'This is the most common shape of tombs in Japan.<img width="240px" src="../sites/mozu-furu/assets/img/tooltip/round.jpg" alt="round tomb">'
  },
  {
    "id": 9,
    "type": "Square",
    "description":
      "The tombs of this shape were constructed throughout the Kofun Period. The tombs of sovereigns changed to this square shape in the second half of the Kofun Period (from the end of the 6th century)." +
      '<img width="240px" src="../sites/mozu-furu/assets/img/tooltip/square.jpg" alt="square tomb">'
  },
  {
    "id": 10,
    "type": "Keyhole-shaped mound",
    "description":
      'These are shaped like a keyhole when seen from above, as if a round mound and a square mound have been joined together.' +
      'Most colossal kofun adopt this keyhole shape. Tombs of this shape are unique to Japan, and have been constructed continuously from the beginning to nearly the end of the Kofun Period.' +
      '<img width="200px" src="../sites/mozu-furu/assets/img/tooltip/keyhole.jpg" alt="keyhole-shaped tomb">'
  },
  {
    "id": 11,
    "type": "Scallop-shaped mound",
    "description":
      'This is a kind of keyhole-shaped kofun with the square front part shortened. Tombs of this shape were mainly constructed in the Middle Kofun Period.' +
      '<img width="240px" src="../sites/mozu-furu/assets/img/tooltip/scallop.jpg" alt="scallop-shaped tomb">'
  },
  {
    "id": 12,
    "type": "Round mound",
    "description": 'This is the most common shape of tombs in Japan.<img width="240px" src="../sites/mozu-furu/assets/img/tooltip/round.jpg" alt="round tomb">'
  },
  {
    "id": 13,
    "type": "Square mound",
    "description":
      "The tombs of this shape were constructed throughout the Kofun Period. The tombs of sovereigns changed to this square shape in the second half of the Kofun Period (from the end of the 6th century)." +
      '<img width="240px" src="../sites/mozu-furu/assets/img/tooltip/square.jpg" alt="square tomb">'
  },
  {
    "id": 14,
    "type": '百舌鳥エリア',
    "description": '百舌鳥エリアは，大阪府堺市内の東西・南北約4kmの範囲に広がっています．４世紀後半から５世紀後半にかけて，この一帯には100基を超える古墳が造られました．しかし，都市化の進展などによってその半数が失われ，現存する古墳は44基です．その中には，世界最大級の墳墓である<a href="" class="mf-tooltip-to-detail" data-kofun="nintoku">仁徳天皇陵古墳</a>（国内第１位）や<a href="" class="mf-tooltip-to-detail" data-kofun="richu">履中天皇陵</a>（同３位）をはじめとする巨大な前方後円墳が含まれています．'
  },
  {
    "id": 15,
    "type": '古市エリア',
    "description": '古市エリアは大阪府の東南部，藤井寺市から羽曳野市にかけて，東西・南北各4kmの範囲に広がっています．４世紀後半から6世紀前半にかけて形成されたこの巨大古墳群は，墳丘長400mを越える巨大前方後円墳である<a href="" class="mf-tooltip-to-detail" data-kofun="ojin">応神天皇陵古墳</a>（国内第２位）をはじめ，小型の方墳まで様々な墳形と規模の古墳からなります．現存する45基のうち7基は，墳丘長200mを越える巨大な前方後円墳です．'
  },
  {
    "id": 16,
    "type": '円墳',
    "description": '日本の古墳で一番多い形状です．<img width="240px" src="../sites/mozu-furu/assets/img/tooltip/round.jpg" alt="round tomb">'
  },
  {
    "id": 17,
    "type": '方墳',
    "description":
      '古墳時代を通して造られていましたが，古墳時代後半（6世紀末以降）には，大王の墓も方墳に変わっていきました．' +
      '<img width="240px" src="../sites/mozu-furu/assets/img/tooltip/square.jpg" alt="square tomb">'
  },
  {
    "id": 18,
    "type": '前方後円墳',
    "description":
      '円（円墳）と四角（方墳）を連結させたような形で，上から見ると鍵穴の形をしています．巨大古墳のほとんどは前方後円墳です．この形状は日本独自のもので，古墳時代を通して造られました．' +
      '<img width="200px" src="../sites/mozu-furu/assets/img/tooltip/keyhole.jpg" alt="keyhole-shaped tomb">'
  },
  {
    "id": 19,
    "type": '帆立貝形墳',
    "description":
      '前方後円墳の一種で，前方部を短くした古墳です．おもに古墳時代の中期に造られていました．' +
      '<img width="240px" src="../sites/mozu-furu/assets/img/tooltip/scallop.jpg" alt="scallop-shaped tomb">'
  },
  {
    "id": 20,
    "type": '모즈 지역',
    "description": '百舌鳥エリアは，大阪府堺市内の東西・南北約4kmの範囲に広がっています．４世紀後半から５世紀後半にかけて，この一帯には100基を超える古墳が造られました．しかし，都市化の進展などによってその半数が失われ，現存する古墳は44基です．その中には，世界最大級の墳墓である<a href="" class="mf-tooltip-to-detail" data-kofun="nintoku">仁徳天皇陵古墳</a>（国内第１位）や<a href="" class="mf-tooltip-to-detail" data-kofun="richu">履中天皇陵</a>（同３位）をはじめとする巨大な前方後円墳が含まれています．'
  },
  {
    "id": 21,
    "type": '후루이치 지역',
    "description": '古市エリアは大阪府の東南部，藤井寺市から羽曳野市にかけて，東西・南北各4kmの範囲に広がっています．４世紀後半から6世紀前半にかけて形成されたこの巨大古墳群は，墳丘長400mを越える巨大前方後円墳である<a href="" class="mf-tooltip-to-detail" data-kofun="ojin">応神天皇陵古墳</a>（国内第２位）をはじめ，小型の方墳まで様々な墳形と規模の古墳からなります．現存する45基のうち7基は，墳丘長200mを越える巨大な前方後円墳です．'
  },
  {
    "id": 22,
    "type": '원분',
    "description": '日本の古墳で一番多い形状です．<img width="240px" src="../sites/mozu-furu/assets/img/tooltip/round.jpg" alt="round tomb">'
  },
  {
    "id": 23,
    "type": '방분',
    "description":
      '古墳時代を通して造られていましたが，古墳時代後半（6世紀末以降）には，大王の墓も方墳に変わっていきました．' +
      '<img width="240px" src="../sites/mozu-furu/assets/img/tooltip/square.jpg" alt="square tomb">'
  },
  {
    "id": 24,
    "type": '전방후원분',
    "description":
      '円（円墳）と四角（方墳）を連結させたような形で，上から見ると鍵穴の形をしています．巨大古墳のほとんどは前方後円墳です．この形状は日本独自のもので，古墳時代を通して造られました．' +
      '<img width="200px" src="../sites/mozu-furu/assets/img/tooltip/keyhole.jpg" alt="keyhole-shaped tomb">'
  },
  {
    "id": 25,
    "type": '가리비형 고분',
    "description":
      '前方後円墳の一種で，前方部を短くした古墳です．おもに古墳時代の中期に造られていました．' +
      '<img width="240px" src="../sites/mozu-furu/assets/img/tooltip/scallop.jpg" alt="scallop-shaped tomb">'
  },
  {
    "id": 26,
    "type": '百舌鸟地区',
    "description": '百舌鳥エリアは，大阪府堺市内の東西・南北約4kmの範囲に広がっています．４世紀後半から５世紀後半にかけて，この一帯には100基を超える古墳が造られました．しかし，都市化の進展などによってその半数が失われ，現存する古墳は44基です．その中には，世界最大級の墳墓である<a href="" class="mf-tooltip-to-detail" data-kofun="nintoku">仁徳天皇陵古墳</a>（国内第１位）や<a href="" class="mf-tooltip-to-detail" data-kofun="richu">履中天皇陵</a>（同３位）をはじめとする巨大な前方後円墳が含まれています．'
  },
  {
    "id": 27,
    "type": '古市地区',
    "description": '古市エリアは大阪府の東南部，藤井寺市から羽曳野市にかけて，東西・南北各4kmの範囲に広がっています．４世紀後半から6世紀前半にかけて形成されたこの巨大古墳群は，墳丘長400mを越える巨大前方後円墳である<a href="" class="mf-tooltip-to-detail" data-kofun="ojin">応神天皇陵古墳</a>（国内第２位）をはじめ，小型の方墳まで様々な墳形と規模の古墳からなります．現存する45基のうち7基は，墳丘長200mを越える巨大な前方後円墳です．'
  },
  {
    "id": 28,
    "type": '圆坟',
    "description": '日本の古墳で一番多い形状です．<img width="240px" src="../sites/mozu-furu/assets/img/tooltip/round.jpg" alt="round tomb">'
  },
  {
    "id": 29,
    "type": '方坟',
    "description":
      '古墳時代を通して造られていましたが，古墳時代後半（6世紀末以降）には，大王の墓も方墳に変わっていきました．' +
      '<img width="240px" src="../sites/mozu-furu/assets/img/tooltip/square.jpg" alt="square tomb">'
  },
  {
    "id": 30,
    "type": '前方后圆坟',
    "description":
      '円（円墳）と四角（方墳）を連結させたような形で，上から見ると鍵穴の形をしています．巨大古墳のほとんどは前方後円墳です．この形状は日本独自のもので，古墳時代を通して造られました．' +
      '<img width="200px" src="../sites/mozu-furu/assets/img/tooltip/keyhole.jpg" alt="keyhole-shaped tomb">'
  },
  {
    "id": 31,
    "type": '扇贝形坟',
    "description":
      '前方後円墳の一種で，前方部を短くした古墳です．おもに古墳時代の中期に造られていました．' +
      '<img width="240px" src="../sites/mozu-furu/assets/img/tooltip/scallop.jpg" alt="scallop-shaped tomb">'
  },
  {
    "id": 32,
    "type": '百舌鳥地區',
    "description": '百舌鳥エリアは，大阪府堺市内の東西・南北約4kmの範囲に広がっています．４世紀後半から５世紀後半にかけて，この一帯には100基を超える古墳が造られました．しかし，都市化の進展などによってその半数が失われ，現存する古墳は44基です．その中には，世界最大級の墳墓である<a href="" class="mf-tooltip-to-detail" data-kofun="nintoku">仁徳天皇陵古墳</a>（国内第１位）や<a href="" class="mf-tooltip-to-detail" data-kofun="richu">履中天皇陵</a>（同３位）をはじめとする巨大な前方後円墳が含まれています．'
  },
  {
    "id": 33,
    "type": '古市地區',
    "description": '古市エリアは大阪府の東南部，藤井寺市から羽曳野市にかけて，東西・南北各4kmの範囲に広がっています．４世紀後半から6世紀前半にかけて形成されたこの巨大古墳群は，墳丘長400mを越える巨大前方後円墳である<a href="" class="mf-tooltip-to-detail" data-kofun="ojin">応神天皇陵古墳</a>（国内第２位）をはじめ，小型の方墳まで様々な墳形と規模の古墳からなります．現存する45基のうち7基は，墳丘長200mを越える巨大な前方後円墳です．'
  },
  {
    "id": 34,
    "type": '圓墳',
    "description": '日本の古墳で一番多い形状です．<img width="240px" src="../sites/mozu-furu/assets/img/tooltip/round.jpg" alt="round tomb">'
  },
  {
    "id": 35,
    "type": '方墳',
    "description":
      '古墳時代を通して造られていましたが，古墳時代後半（6世紀末以降）には，大王の墓も方墳に変わっていきました．' +
      '<img width="240px" src="../sites/mozu-furu/assets/img/tooltip/square.jpg" alt="square tomb">'
  },
  {
    "id": 36,
    "type": '前方後圓墳',
    "description":
      '円（円墳）と四角（方墳）を連結させたような形で，上から見ると鍵穴の形をしています．巨大古墳のほとんどは前方後円墳です．この形状は日本独自のもので，古墳時代を通して造られました．' +
      '<img width="200px" src="../sites/mozu-furu/assets/img/tooltip/keyhole.jpg" alt="keyhole-shaped tomb">'
  },
  {
    "id": 37,
    "type": '扇貝形墳',
    "description":
      '前方後円墳の一種で，前方部を短くした古墳です．おもに古墳時代の中期に造られていました．' +
      '<img width="240px" src="../sites/mozu-furu/assets/img/tooltip/scallop.jpg" alt="scallop-shaped tomb">'
  }
]



// WEBPACK FOOTER //
// ./map/js/ih/data/tooltip_mozu-furu.js